import type { ServerConfig } from '@/@types';

export const serverConfig: ServerConfig = {
  subject: '开发环境',
  environment: 'development',
  // apiSrc: 'http://192.168.2.33:8080',
  apiSrc: 'https://saas-api.vansunscience.com', // 192.168.2.67:8080
  questionarySrc: 'https://que-design.vansunscience.com',
};
